import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";

export interface IAmazonMvlImportResult {
  imported: number;
  skipped: number;
  totalRows: number;
}

export default function useMvl() {
  const { get, postDocs } = useApiHelper();
  const queryClient = useQueryClient();

  const count = useQuery({
    queryKey: ["mvl", "count"],
    queryFn: () => get<IDefaultResponse<number>>("/mvlimport/count").then((res) => res.data),
  });

  const importXlsx = useMutation({
    mutationFn: async ({ file, truncate }: { file: File; truncate: boolean }) => {
      const formData = new FormData();
      formData.append("file", file);
      return postDocs<IDefaultResponse<IAmazonMvlImportResult>>(
        `/mvlimport/import?truncate=${truncate}`,
        formData
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mvl", "count"] });
    },
  });

  return {
    count,
    importXlsx,
  };
}
